module.exports = {
    title: 'Reset Layout',
    titleStringId: 'resetTrackingLayout',
    id: 'reset_layout',
    type: 'reset-layout',
};
